import type { FeatureFlagKey } from '@vizit/constants';
import * as React from 'react';
import { useFeatureFlags } from './use-feature-flags';

/**
 * Hook to get a specific feature flag value
 */
export function useFeatureFlag<T = boolean>(flagKey: FeatureFlagKey, defaultValue: T): T {
  const { getFlag } = useFeatureFlags();

  // Re-render when overrides change
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);
  React.useEffect(() => {
    window.addEventListener('flag-override-changed', forceUpdate);
    return () => window.removeEventListener('flag-override-changed', forceUpdate);
  }, []);

  return getFlag(flagKey, defaultValue);
}
